import { Link } from "react-router-dom";
import { ArrowUpRight, Building2, Sprout, Tractor, Forklift } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { HomeSection, HomeSectionHeader } from "@/components/home/HomeSection";

const UNIVERSES = [
  {
    id: "building",
    category: "btp-chantier",
    titleKey: "home.universe_building_title",
    descKey: "home.universe_building_desc",
    Icon: Building2,
  },
  {
    id: "garden",
    category: "espaces-verts",
    titleKey: "home.universe_garden_title",
    descKey: "home.universe_garden_desc",
    Icon: Sprout,
  },
  {
    id: "agri",
    category: "agricole",
    titleKey: "home.universe_agri_title",
    descKey: "home.universe_agri_desc",
    Icon: Tractor,
  },
  {
    id: "industry",
    category: "outillage-professionnel",
    titleKey: "home.universe_industry_title",
    descKey: "home.universe_industry_desc",
    Icon: Forklift,
  },
];

export function HomeUniverses() {
  const { t } = useLang();

  return (
    <HomeSection tone="muted" testId="home-universes">
      <HomeSectionHeader
        kicker={t("home.universes_kicker")}
        title={t("home.universes_title")}
        subtitle={t("home.universes_subtitle")}
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
        {UNIVERSES.map(({ id, category, titleKey, descKey, Icon }) => (
          <Link
            key={id}
            to={`/recherche?category=${encodeURIComponent(category)}`}
            data-testid={`home-universe-${id}`}
            className="matpass-card-hover group flex flex-col overflow-hidden rounded-2xl border border-matpro-border bg-white shadow-[0_8px_24px_rgba(24,24,27,0.06)] hover:border-matpro-green focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-matpro-green"
          >
            <div className="flex items-center justify-center px-5 pt-6 pb-2">
              <div className="flex h-24 w-24 items-center justify-center rounded-[18px] bg-[#F0FDF4] transition-transform duration-300 ease-out group-hover:scale-[1.03]">
                <Icon
                  className="h-10 w-10 text-[#16A34A]"
                  strokeWidth={1.5}
                  aria-hidden
                />
              </div>
            </div>

            <div className="flex flex-1 flex-col p-5 pt-4 text-center sm:text-left">
              <div className="relative">
                <h3 className="px-10 font-heading text-lg font-bold text-matpro-anthracite sm:px-0 sm:pr-10">
                  {t(titleKey)}
                </h3>
                <span className="absolute right-0 top-0.5 inline-flex h-8 w-8 items-center justify-center rounded-xl bg-matpro-green-light text-matpro-green transition-colors duration-300 group-hover:bg-matpro-green group-hover:text-white">
                  <ArrowUpRight className="h-4 w-4" />
                </span>
              </div>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-matpro-anthracite-muted">
                {t(descKey)}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </HomeSection>
  );
}
